import "./Card.css";
import comingsoon from "./metasploit-unleashed-exploit-development.png";

function Card() {
    return (
      <div className="Activitiescardcss">
        <img className="ActImage" src={comingsoon} alt={""}></img>
      </div>
    );
  }
  
export default Card;